var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalseIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.60682 0 0 5.60682 0 12.5C0 19.3932 5.60682 25 12.5 25C19.3932 25 25 19.3932 25 12.5C25 5.60682 19.3932 0 12.5 0ZM12.5 22.6902C6.87919 22.6902 2.30705 18.118 2.30705 12.4972C2.30705 6.8764 6.87919 2.30425 12.5 2.30425C18.1208 2.30425 22.693 6.87919 22.693 12.5C22.693 18.1208 18.1208 22.6902 12.5 22.6902Z",
    fill: "#006AB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6374 6.36208C18.1872 5.91186 17.4573 5.91186 17.0071 6.36208L12.4992 10.8671L7.99422 6.36208C7.54399 5.91186 6.81413 5.91186 6.3639 6.36208C5.91368 6.81231 5.91368 7.54217 6.3639 7.99239L10.8689 12.5002L6.36111 17.0053C5.91088 17.4555 5.91088 18.1853 6.36111 18.6356C6.58762 18.8621 6.88124 18.9739 7.17766 18.9739C7.47408 18.9739 7.76771 18.8621 7.99422 18.6356L12.4992 14.1305L17.0043 18.6356C17.2308 18.8621 17.5244 18.9739 17.8208 18.9739C18.1173 18.9739 18.4109 18.8621 18.6374 18.6356C19.0876 18.1853 19.0876 17.4555 18.6374 17.0053L14.1296 12.5002L18.6346 7.99519C19.0876 7.54217 19.0876 6.81231 18.6374 6.36208Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalseIconActive);
export default __webpack_public_path__ + "static/media/falseIconActive.ac0396684cfec43286acf2829a30ae24.svg";
export { ForwardRef as ReactComponent };